import isImageProxyEnabled from './isImageProxyEnabled';
import isProxyImage from './isProxyImage';
import loadFromModelDProxy from './loadFromModelDProxy';
import loadFromModelBProxy from './loadFromModelBProxy';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Load an image from proxy
 * @param img The image
 */
export default function loadFromProxy(img: HTMLImageElement) {
    // Return false if it is not a proxy capable image
    // so that it can be handled by next handler in the chain
    if (!isProxyImage(img)) {
        return false;
    }

    if (isImageProxyEnabled()) {
        if (isFeatureEnabled('rp-imageProxyOnModelD')) {
            loadFromModelDProxy(img, true /* shadowTraffic */);
        } else {
            loadFromModelBProxy(img);
        }
    } else {
        //Block the image when External Images setting is disabled.
        img.src = '';
    }

    return true;
}
